import LtiLaunchRequest from '../api/ltiLaunchRequest';
import { applicationFetch } from './applicationActions';

export const fetchLtiLaunchRequest = applicationFetch(LtiLaunchRequest);
